// extracted by mini-css-extract-plugin
module.exports = {"loader":"_2QNRTB-axOZThyekIR_Jeo","spinner":"_23hNT5TD3v-sCc1t8T4rb8"};